import apple from "../../../assets/footer/apple.svg";
import ruStore from "../../../assets/footer/ruStore.png";

export const footerBadges = [
    {
        id: "badge-1",
        title: "Мобильных устройствах",
        head: "доступно на",
        // img: ruStore,
        link: "https://mobile-hr.alrosa.ru/",
    },
    // {
    //     id: "badge-2",
    //     title: "App Store",
    //     head: "загрузите в",
    //     img: apple,
    //     link: "https://apps.apple.com/app/id1579026870",
    // },
];
